import React from "react";
import { Link } from "react-router-dom";
import { ArticleSummary } from "./types";
import Byline from "./Byline";
// Three sizes: `lead` (the one highlighted article: cover, title,
// standfirst, byline and, when the author linked one, the related project),
// `compact` (the supporting cards beside it: cover, title, byline) and the
// default grid card. The project box appears only when the author chose one.
export default function ArticleCard({
  article,
  lead = false,
  compact = false,
  showProject = true,
}: {
  article: ArticleSummary;
  lead?: boolean;
  compact?: boolean;
  showProject?: boolean;
}) {
  return (
    <article className={"bl-card" + (lead ? " bl-lead" : "") + (compact ? " bl-compact" : "")}>
      {article.cover && (
        <figure>
          <Link to={article.url}>
            <img src={article.cover.url} alt={article.cover.alt} loading={lead ? undefined : "lazy"} />
          </Link>
          {lead && article.cover.caption && <figcaption>{article.cover.caption}</figcaption>}
        </figure>
      )}
      <div className="bl-card-text">
        <div className="er-kicker">
          <Link to={article.categoryUrl}>{article.categoryLabel}</Link>
          {showProject && article.project && (
            <>
              {" "}· {article.project.year} · {article.project.team}
            </>
          )}
        </div>
        <h3>
          <Link to={article.url}>{article.title}</Link>
        </h3>
        {!compact && article.standfirst && <p className="er-deck">{article.standfirst}</p>}
        <Byline author={article.author} date={article.publishedAt} size={compact ? 26 : 32} />
        {lead && article.project && (
          <aside className="bl-related">
            <div className="er-kicker">Related project · {article.project.team} · iDEC {article.project.year}</div>
            <p>{article.project.headline}</p>
            <div className="er-links">
              <a href={article.project.wikiUrl} target="_blank" rel="noopener noreferrer">
                Explore Wiki ↗
              </a>
              {article.project.articles.slice(0, 1).map((a) => (
                <a key={a.articleId} href={a.url}>
                  Read preprint →
                </a>
              ))}
            </div>
          </aside>
        )}
        <p className="bl-read">
          <Link to={article.url}>Read the article →</Link>
        </p>
      </div>
    </article>
  );
}
